<template>
  <section class="fill-height">
    <v-toolbar color="#9190b5" dark prominent src="https://picsum.photos/1920/1080?random">
      <template v-slot:img="{ props }">
        <v-img v-bind="props" gradient="to top right, rgba(145,144,181,.7), rgba(25,32,72,.7)"></v-img>
      </template>
      <v-toolbar-title>{{ $route.name }}</v-toolbar-title>
      <v-spacer/>
      <template v-slot:extension>
        <v-text-field hide-details clearable solo-inverted placeholder="Search" dense v-model="invoices.search"></v-text-field>
      </template>
    </v-toolbar>

    <v-container fluid>
      <v-card>
        <v-data-table :headers="invoices.headers"
                      :items="invoices.items"
                      :search="invoices.search">
          <template v-slot:item.session_types="{ value }">
            <div v-for="(item, idx) in value" :key="idx">
              {{ item.short_name }} - {{ item.count }}
            </div>
          </template>

          <template v-slot:item.created_at="{ value }">
            {{ $moment(value).format('DD/MM/YYYY hh:mm A')}}
          </template>
<!--          <template v-slot:item.actions="{ item }">-->
<!--            <v-btn small color="primary" class="box-shadow"-->
<!--                   @click="openSelectedItemDialog(item)">open</v-btn>-->
<!--          </template>-->
        </v-data-table>
      </v-card>
    </v-container>
  </section>
</template>

<script>
// import DateField from "@/components/DateField";
export default {
  // components: {DateField},
  data: () => ({
    invoices: {
      headers: [
        { text: 'External ID', value: 'external_id' },
        { text: 'Description', value: 'description' },
        { text: 'Sessions', value: 'session_types' },
        { text: 'Amount', value: 'amount' },
        { text: 'Tax Amount', value: 'tax_amount' },
        { text: 'Total', value: 'total' },
        { text: 'Date', value: 'created_at' },
        { text: 'Status', value: 'status' },
        // { text: 'Actions', value: 'actions', sort: false },
      ],
      items: [],
      search: '',
      date_from: '',
      date_to: '',
    }
  }),
  watch: {
    'invoices.date_from': function(oldVal, val) {
      if(oldVal !== null && val !== null){
        this.loadData()
      }
    },
    'invoices.date_to': function(oldVal, val) {
      if(oldVal !== null && val !== null){
        this.loadData()
      }
    },
  },
  created() {
    this.invoices.date_from = this.$currentTime().subtract(1, 'months').format('YYYY-MM-DD')
    this.invoices.date_to = this.$currentTime().format('YYYY-MM-DD')
    this.loadData()
  },
  methods: {
    async loadData() {
      this.invoices.items = await this.axios.post('api/user/invoices').then(({data}) => data.data)
    }
  }
}
</script>